import { SimpleGrid } from 'src/design/atoms/SimpleGrid';
import React from 'react';
import { Scope } from 'src/data/scopes';
import { useAuth } from 'src/hooks/useAuth';
import { EmptyState } from 'src/design/atoms/EmptyState';
import { Header } from 'src/design/organisms/Header';
import { ReportCard } from 'src/design/molecules/ReportCard';

interface ReportDefinition {
  title: string;
  description: string;
  link: string;
  requiredScopes: Scope[];
}

const REPORTS: ReportDefinition[] = [
  {
    title: 'Timesheet Payroll Report',
    description:
      'Generate aggregated timesheet payroll statements for your organization.',
    link: '/reports/timesheet-payroll',
    requiredScopes: ['reports_timesheet_payroll'],
  },
  {
    title: 'Timesheet Audit Report',
    description:
      'Generate detailed individual timesheet audit reports with history and signatures.',
    link: '/reports/timesheet-audit',
    requiredScopes: ['reports_timesheet_audit'],
  },
  {
    title: 'Daily Submission Report',
    description:
      'Review which users submitted daily reports each day of a work week.',
    link: '/reports/daily-submission',
    requiredScopes: ['jobs_dailys'],
  },
];

export const Reports: React.FC = () => {
  const { checkFeatureAllowed } = useAuth();
  const allowedReports = REPORTS.filter((report) =>
    checkFeatureAllowed(report.requiredScopes),
  );

  return (
    <>
      <Header
        breadcrumbProps={{
          items: [{ text: 'Reports' }],
        }}
        title="Reports"
        helpText="Generate reports for your organization."
      />

      {allowedReports.length === 0 ? (
        <EmptyState
          header="No reports available"
          description="You do not have access to any reports."
        />
      ) : (
        <SimpleGrid cols={{ base: 1, md: 3, lg: 4 }}>
          {allowedReports.map((report) => (
            <ReportCard
              key={report.title}
              title={report.title}
              description={report.description}
              link={report.link}
            />
          ))}
        </SimpleGrid>
      )}
    </>
  );
};
